// extracted by mini-css-extract-plugin
export var content = "layoutLoggedIn-module--content--4e483";
export var footer = "layoutLoggedIn-module--footer--a57c6";
export var navContainer = "layoutLoggedIn-module--nav-container--43cb1";
export var sidebar = "layoutLoggedIn-module--sidebar--f3e2b";
export var wrapper = "layoutLoggedIn-module--wrapper--0a581";